import React, {
  memo,
} from 'react';
import { Button } from '@mui/material';
import Grid24 from '../../../../components/UI/Grid24';

function DialogImprimirTermoAcordo({
  onConfirmImprimirTermoAcordo,
  setOpenDialogImprimirTermoAcordo,
}) {
  return (
    <>
      <Grid24 container isFormContainer spacing="1">
        Ao imprimir a primeira parcela você também poderá alterar seu Status para “Aguardando Pagamento”. Que ação você deseja executar?
      </Grid24>
      <div style={{ display: 'flex', justifyContent: 'end', marginTop: '22px' }}>
        <Button
          onClick={() => setOpenDialogImprimirTermoAcordo(false)}
        >
          Cancelar
        </Button>
        <Button
          onClick={() => {
            onConfirmImprimirTermoAcordo(false);
            setOpenDialogImprimirTermoAcordo(false);
          }} // Não altera fase
        >
          Somente imprimir
        </Button>
        <Button
          onClick={() => {
            onConfirmImprimirTermoAcordo(true);
            setOpenDialogImprimirTermoAcordo(false);
          }} // Altera fase
        >
          Imprimir e atualizar o Status
        </Button>
      </div>

    </>
  );
}
export default memo(DialogImprimirTermoAcordo);
